import React from 'react';
import { Box, Typography, TextField, Button, Divider, CircularProgress, MenuItem } from '@mui/material';

const ESTADOS_VALIDOS = ['Pendiente', 'Creado', 'En tránsito', 'Retrasado', 'Entregado','En Bodega'];

export default function EnvioConsulta({
  consultaGuia,
  setConsultaGuia,
  envioConsultado,
  onConsultar,
  historial,
  onCerrar,
  isAdmin,
  estado,
  setEstado,
  onActualizarEstado,
  loadingConsulta,
  loadingActualizar,
  errorMessage
}) {
  return (
    <Box sx={{ mt: 3 }}>
      <Divider sx={{ my: 3 }} />
      <Typography variant="h6">🔎 Consultar envío por número de guía</Typography>

      <TextField
        label="Número de guía"
        fullWidth
        margin="normal"
        value={consultaGuia}
        onChange={(e) => setConsultaGuia(e.target.value.trim())}
      />
      <Button
        variant="contained"
        color="secondary"
        onClick={onConsultar}
        disabled={!consultaGuia.trim() || loadingConsulta}
      >
        {loadingConsulta ? <CircularProgress size={24} color="inherit" /> : 'Consultar'}
      </Button>

      {errorMessage && (
        <Typography color="error" sx={{ mt: 1 }}>
          {errorMessage}
        </Typography>
      )}

      {envioConsultado && (
        <Box sx={{ mt: 2 }}>
          <Typography variant="subtitle1">
            <strong>{envioConsultado.numeroGuia}</strong> — {envioConsultado.tipoEnvio}
          </Typography>
          <Typography variant="body2" color="textSecondary">
            Estado: {envioConsultado.estado} | Casillero: {envioConsultado.casilleroCodigo || '—'}
          </Typography>
          <Typography variant="body2" color="textSecondary">
            Origen: {envioConsultado.origen} → Destino: {envioConsultado.destino}
          </Typography>

          {/* Mostrar historial si existe */}
          {historial?.length > 0 && (
            <Box sx={{ mt: 2 }}>
              <Typography variant="subtitle2">📜 Historial:</Typography>
              {historial.map((h, i) => (
                <Typography key={i} variant="body2">
                  {h.fecha ? new Date(h.fecha).toLocaleString() : ''} — {h.estado}
                </Typography>
              ))}
            </Box>
          )}

          <Button sx={{ mt: 1 }} onClick={onCerrar}>
            Cerrar
          </Button>

          {isAdmin && (
            <>
              <Divider sx={{ my: 2 }} />
              <Typography variant="h6">🔄 Actualizar estado</Typography>
              <TextField
                select
                label="Nuevo estado"
                fullWidth
                margin="normal"
                value={estado}
                onChange={(e) => setEstado(e.target.value)}
              >
                {ESTADOS_VALIDOS.map((opt) => (
                  <MenuItem key={opt} value={opt}>
                    {opt}
                  </MenuItem>
                ))}
              </TextField>
              <Button
                variant="contained"
                color="secondary"
                onClick={onActualizarEstado}
                disabled={!estado.trim() || loadingActualizar}
              >
                {loadingActualizar ? <CircularProgress size={24} color="inherit" /> : 'Actualizar estado'}
              </Button>
            </>
          )}
        </Box>
      )}
    </Box>
  );
}